const baseURL = "/v1/Faq";

const service = {
  methods: {
    $buscarFaqs(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarFaq(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarFaq(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarFaq(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarFaq(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    },
  },
};

export default service;